// extracted by mini-css-extract-plugin
export default {"cardBody":"home-page_cardBody__StyHS","featuredCard":"home-page_featuredCard__d2okr"};